<ng-container *transloco="let t">
  <lib-modal
    [title]="t('betalningsuppgift_reminder_title')"
    [showCloseButton]="true"
    [showPrimaryButton]="true"
    [showSecondaryButton]="true"
    [secondaryButtonText]="t('betalningsuppgift_reminder_secondary')"
    [primaryButtonText]="t('betalningsuppgift_reminder_primary')"
    (closeModal)="modalService.hide()"
    (secondaryButton)="modalService.hide()"
    (primaryButton)="goToMinProfil()"
    ><p>
      {{ t('betalningsuppgift_reminder_body') }}
    </p></lib-modal
  >
</ng-container>
